import Model from 'src/storage/base';

class OAuthModel extends Model {
  id = 'OAuthModel';
  persistent = false;

  apiConfig = {
    check: {
      url: 'auth/gAuth',
      validation: {
        code: 'code'
      },
      cancellable: true
    }
  };

  check = (code, cb) => {
    this.api('check', { code }, (error, data, success) => {
      cb(error, data, success);
    });
  };
}

const model = new OAuthModel();
export default model;
